module.exports = __webpack_public_path__ + "img/rolePer.bb875db9.svg";